import PerformanceOverview from './PerformanceOverview.vue';
import VcomProvider from '../../VcomProvider';
const app = { component: PerformanceOverview, options: {} };
VcomProvider.VueAppMounter.registerPortlet('performance-overview', app);
